import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TrainerInfo from './trainer-info';
import Overview from './overview';
import Cta from './cta';

const OverviewBox = ({ sharedWorkout: { trainer, activityLog, workout }, user, toggleModal }) => {
  return (
    <aside className="overview-info">
      { trainer &&
        <TrainerInfo
          trainer={ trainer }
        />
      }
      <Overview />
      { activityLog
        ? <Cta
          link={ `/login?next=%2Fshared/workout/${ activityLog._id }?show=true` }
          user={ user }
          toggleModal={ toggleModal }
        />
        : <Cta
          link={ `/login?next=%2Fshared/w/${ workout._id }?show=true` }
          user={ user }
          toggleModal={ toggleModal }
        />
      }
    </aside>
  );
};

OverviewBox.propTypes = {
  sharedWorkout: PropTypes.object.isRequired,
  user: PropTypes.object,
  toggleModal: PropTypes.function
};

const ConnectedOverviewBox = connect((state) => {
  return {
    sharedWorkout: state.sharedWorkout,
    user: state.user
  };
})(OverviewBox);

export default ConnectedOverviewBox;